/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { asField } from "informed";
import ValidateItem from "../../../helpers/validation/validateInput";
import RangeSlider from "../../ui/RangeSlider";
import validatehoc from "../Validator";

class NumberInput extends Component {
	constructor(props) {
		super(props);

		this.step = props.step ? props.step : 1;
		this.min = props.min ? props.min : 0;
		this.max = props.max ? props.max : 100;
		this.state = {
			minimizePlaceholder: false,
			value: props.fieldState.initialValue,
		};
	}

	validate = value => {
		const { placeholder, isRequired, validationRegex, minLength, maxLength, regexMessage } = this.props;
		return ValidateItem(value, placeholder, isRequired, validationRegex, minLength, maxLength, regexMessage);
	};

	updateValue = newValue => {
		if (newValue > this.props.max) {
			newValue = this.props.max;
		} else if (newValue < this.props.min) {
			newValue = this.props.min;
		}
		this.props.fieldApi.setValue(newValue);
		this.props.fieldApi.setTouched(true);
	};

	render() {
		const { fieldState, placeholder, min, max } = this.props;
		const { value, error } = fieldState;
		const hasError = error || isNaN(value) ? " has-error" : "";
		return (
			<div>
				<RangeSlider
					onChange={this.updateValue}
					error={hasError}
					value={value}
					min={min}
					max={max}
					placeholder={placeholder}
				/>
			</div>
		);
	}
}

NumberInput.propTypes = {
	field: PropTypes.string,
	id: PropTypes.string,
	placeholder: PropTypes.string,
	autocomplete: PropTypes.string,
	isRequired: PropTypes.bool,
	minLength: PropTypes.number,
	maxLength: PropTypes.number,
	validationRegex: PropTypes.string,
	regexMessage: PropTypes.string,
	type: PropTypes.string,
	themeId: PropTypes.string,
	fieldState: PropTypes.object,
	fieldApi: PropTypes.object,
	min: PropTypes.number,
	max: PropTypes.number,
	step: PropTypes.number,
};

const Wrapper = validatehoc(
	asField(({ fieldState, ...props }) => <NumberInput fieldState={fieldState} {...props} />),
	"number"
);

export default Wrapper;
